import apiClient from './client';
import { ApiResponse } from '@/types';

/**
 * RocketChat connection status
 */
export interface RocketChatStatus {
  connected: boolean;
  botUsername?: string;
  botUserId?: string;
}

/**
 * Get RocketChat connection status
 */
export async function getRocketChatStatus(): Promise<RocketChatStatus> {
  const response = await apiClient.get<ApiResponse<RocketChatStatus>>('/rocketchat/status');
  return response.data.data as RocketChatStatus;
}

/**
 * Test/establish RocketChat connection
 */
export async function connectRocketChat(): Promise<{ connected: boolean; message: string }> {
  const response = await apiClient.post<ApiResponse<{ connected: boolean; message: string }>>('/rocketchat/connect');
  return response.data.data as { connected: boolean; message: string };
}
